import { superstructResolver } from '@hookform/resolvers/superstruct';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ButtonCancel, ButtonSave } from '@adflow/frontend/ui-buttons';
import { InputTextFieldWithControl } from '@adflow/frontend/ui-form';
import { Modal } from '@adflow/frontend/ui-modal';
import { useMutationResetPassword } from '@adflow/frontend/util-auth';
import { AddPasswordResetDto } from '@adflow/shared/util-auth';

const modalFormSchema = AddPasswordResetDto;
type modalFormValues = AddPasswordResetDto;

interface ResetPasswordModalProps {
	show: boolean;
	handleClose: () => void;
	email: string;
}

export function ResetPasswordModal({
	show,
	handleClose,
	email,
}: ResetPasswordModalProps) {
	const { t } = useTranslation('login');

	const { mutateAsync: requestResetPassword } = useMutationResetPassword();

	const modalFormMethods = useForm<modalFormValues>({
		defaultValues: { email },
		resolver: superstructResolver(modalFormSchema, {
			coerce: true,
			mask: true,
		}),
	});
	const { handleSubmit, reset } = modalFormMethods;

	const handleResetPassword = handleSubmit(async (data) => {
		await requestResetPassword(data);
		handleClose();
	});

	useEffect(() => {
		reset({ email });
	}, [email, reset]);

	return (
		<Modal
			show={show}
			onRequestClose={handleClose}
			dialogStyleOverrides={{
				width: '420px',
			}}
		>
			<form onSubmit={handleResetPassword}>
				<Modal.Header>{t('Reset Password')}</Modal.Header>
				<Modal.Body>
					<FormProvider {...modalFormMethods}>
						<InputTextFieldWithControl
							name="email"
							label={t('form label Email')}
							placeholder={t('Enter your email')}
							autoFocus
							type="email"
							forceAutoComplete
						/>
					</FormProvider>
				</Modal.Body>
				<Modal.Footer>
					<ButtonCancel onClick={handleClose} />
					<ButtonSave type="submit">{t('Request password reset')}</ButtonSave>
				</Modal.Footer>
			</form>
		</Modal>
	);
}
